import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { GlobalModalContentDirective } from './global-modal-content.directive';
import { GlobalModalComponent } from './global-modal.component';

@NgModule({
    imports: [CommonModule, FormsModule, RouterModule, CoreUiModule],
    declarations: [GlobalModalComponent, GlobalModalContentDirective],
    exports: [GlobalModalComponent, GlobalModalContentDirective],
    providers: []
})
export class GlobalModalModule {}
